import React from 'react';
import HeroSection from '../components/LandingPageNew/HeroSection';
import Steps from '../components/LandingPageNew/Steps';
import Trust from '../components/LandingPageNew/Trust';
import Packages from '../components/LandingPageNew/Packages';
import HowRemove from '../components/LandingPageNew/HowRemove';
import CustomerReviews from '../components/LandingPageNew/CustomerReviews';
import BestSuit from '../components/LandingPageNew/BestSuit';
import Faq from '../components/LandingPageNew/Faq';
import Contact from '../components/LandingPageNew/Contact';
import Overview from '../components/LandingPageNew/Overview';
import Navbar from '../components/LandingPageNew/Navbar';
import one from '../Images/new/1.jpg';
import two from '../Images/new/2.jpg';
import three from '../Images/new/3.jpg';
import four from '../Images/new/4.jpg';
import Footer from '../components/LandingPageNew/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
const LandingPageNew = () => {
  const reviews = [
    {
      name: "K. Schuhmacher",
      role: "Inhaberin Catering",
      image: one,
      text: `"Endlich habe ich wieder Kontrolle über meinen Online-Ruf. Die Erfolgsquote hat mich überzeugt – und dass man nur bei Erfolg zahlt, nimmt jedem die Angst vor unnötigen Kosten."`,
    },
    {
      name: "Dr. Freese ",
      role: "Arzt - Praxisinhaber",
      image: two,
      text: `"Unfaire Bewertungen haben unser Praxisbild stark verzerrt. Mit diesem Service konnten wir mehrere falsche Rezensionen entfernen lassen. Seitdem wirkt unser Profil wieder so, wie Patient:innen es tatsächlich erleben. Ein enormer Unterschied!"`,
    },
    {
      name: "Tim Hannewald",
      role: "Marketing Manager",
      image: three,
      text: `"Die Reputation unseres Unternehmens hat sich deutlich verbessert. Besonders gefällt mir, dass wir wieder sichtbarer auf Google sind."`,
    },
    {
      name: "Nils Schröder",
      role: "Speditionskaufmann",
      image: four,
      text: `"Für unsere Standorte ist die Lösung ideal. Alles lässt sich zentral steuern, und innerhalb kurzer Zeit sah unser Bewertungsprofil wieder seriös aus. Besonders das erfolgsbasierte Modell ist ein starkes Argument."`,
    },
  ];
  const tabs = [
    { id: "general", label: "Allgemein" },
    { id: "process", label: "Prozess" },
    { id: "support", label: "Support" },
  ];
  const faqData = {
    general: [
      {
        question: "Was macht die UNEVA ?",
        answer:
          "UNEVA sorgt dafür, dass Ihr Unternehmen online so wahrgenommen wird, wie Sie es verdienen.  Über unseren intuitiven Self-Service können Sie negative Rezensionen jederzeit selbst melden – einfach und risikofrei. ",
      },
      {
        question: "Warum sollte man negative Bewertungen entfernen lassen?",
        answer:
          "Weil sie oft den ersten Eindruck bestimmen. Unfaire Rezensionen können Interessent:innen abschrecken und Ihrem Ruf schaden. Die Entfernung hilft dabei, wieder vertrauenswürdig aufzutreten und mehr Kund:innen zu gewinnen.",
      },
      {
        question: "Wie funktioniert das genau?",
        answer: `Über unseren Bewertungsmanager wählen Sie direkt aus Ihrem Google-Profil die Bewertungen aus, die Sie melden möchten. Im Anschluss starten Sie den Prozess - ganz ohne Risiko. Die Erfolgsquote liegt derzeit bei 95%.

Nach erfolgreicher Löschung durch den Plattformbetreiber, erhalten Sie eine Rechnung für die erfolgreich entfernten Bewertungen.`,
      },
      {
        question: "Wie lange dauert der Vorgang?",
        answer:
          "Die Dauer variiert je nach Fall. Häufig erfolgt die Entscheidung innerhalb weniger Tage, in manchen Fällen kann es bis zu 3 Wochen dauern. ",
      },
      {
        question: "Warum kann es sinnvoll sein, negative Bewertungen entfernen zu lassen?",
        answer: `Negative Bewertungen können die Außenwirkung eines Unternehmens erheblich beeinflussen. Werden   falsche Bewertungen entfernt, kann sich die Online-Sichtbarkeit verbessern, das Vertrauen potenzieller Kundinnen und Kunden steigen und die Wahrscheinlichkeit für neue Anfragen sowie Abschlüsse erhöhen.`,
      },
      {
        question: "Funktioniert die Löschung über den Asisstent auch für andere Plattformen? ",
        answer: "Ja, gerne kontaktieren Sie uns via Telefon oder E-Mail.",
      },
    ],
    process: [
      {
        question: " Wie funktioniert der Prozess?",
        answer:
          "Sie starten die Löschung  über unseren Bewertungsmanager, wir warten anschließend das Ergebnis ab und senden Ihnen nach erfolgreicher Löschung die Bestätigung sowie die Rechnung zu.",
      },
    ],
    support: [
      {
        question:  "Wie kann ich UNEVA kontaktieren?",
        answer: "Sie können uns über das Kontaktformular oder per E-Mail erreichen.",
      },
    ],
  };

  return (
    <>
      <Navbar />
      <HeroSection />
      <Overview />
      <Steps />
      <Trust />
      <Packages />
      <HowRemove />
      <CustomerReviews reviews={reviews} title="Kundenstimmen"
        subtitle="Entdecken Sie echte Erfolgsgeschichten – von mehr Sichtbarkeit bis hin zu deutlich gesteigertem Wachstum." />
      <BestSuit />
      <Faq
        title={
          <>
            Häufige Fragen, <span className="text-[#0b2b40]">klare</span> Antworten
          </>
        }
        subtitle="Unfaire Bewertungen beeinträchtigen Ihr Profil? Mit unserem Self-Service holen Sie sich die Kontrolle zurück."
        tabs={tabs}
        faqData={faqData}
        defaultTab="general"
      />
      <Contact />
      <Footer/>
      {/* <ScrollToTopButton/> */}
    </>
  );
};

export default LandingPageNew;
